import React from 'react'

const typescriptComponent = () => (
  <div>
    <h2>typescriptComponent</h2>
  </div>
)

export default typescriptComponent



// WEBPACK FOOTER //
// ./src/components/About/Tech/typescriptComponent.js